import { render, staticRenderFns } from "./projectList.vue?vue&type=template&id=a2eca17c&"
import script from "./projectList.vue?vue&type=script&lang=js&"
export * from "./projectList.vue?vue&type=script&lang=js&"
import style0 from "./projectList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports